<template>
  <v-container
    fluid
    class="cashier-page-conteiner"
    :class="{ 'with-floating-buttons': showFloatingButtons }"
  >
    <v-loader
      v-if="isLoading"
      absolute
    />
    <div class="tabs d-flex">
      <div
        v-for="(tab, i) in tabs"
        :key="i"
        :class="{ 'active': tab.value === currentWindow }"
        class="tab"
        @click="goToTab(tab.value)"
      >
        <span class="tab-label">{{ tab.title }}</span>
      </div>
    </div>
    <v-cashier
      v-if="currentWindow === 'cashier'"
      :selected-date="ordersFilterDate"
    />
    <fiscalization
      v-if="currentWindow === 'fiscalization'"
      @close="goToTab('cashier')"
    />
    <v-collection
      v-if="currentWindow === 'collection'"
      @close="goToTab('cashier')"
    />
    <v-replenishment
      v-if="currentWindow === 'replenishment'"
      @close="goToTab('cashier')"
    />
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import VCashier from '@/components/administrator/cashier/Cashier'
  import VReplenishment from '@/components/administrator/replenishment/Replenishment'
  import VCollection from '@/components/administrator/collection/Collection'
  import Fiscalization from '@/components/administrator/fiscalization/Fiscalization.vue'

  export default {
    name: 'Cashier',
    components: {
      VLoader,
      VCashier,
      VReplenishment,
      VCollection,
      Fiscalization,
    },
    data () {
      return {
        isLoading: false,
        currentWindow: 'cashier',
        tabs: [
          { title: 'Касса', value: 'cashier' },
          { title: 'Фискализация и печать', value: 'fiscalization' },
          { title: 'Инкассация', value: 'collection' },
          { title: 'Пополнение', value: 'replenishment' },
        ],
      }
    },
    computed: {
      ...mapState({
        ordersFilterDate: state => state.orders.ordersFilterDate,
        showFloatingButtons: (state) => state.app.showFloatingButtons,
      }),
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (to.query.tab && vm.tabs.some(item => item.value === to.query.tab)) {
          vm.currentWindow = to.query.tab
        }
      })
    },
    beforeRouteUpdate (to, from, next) {
      if (to.query.tab && this.tabs.some(item => item.value === to.query.tab)) {
        this.currentWindow = to.query.tab
      }

      next()
    },
    methods: {
      goToTab (tab) {
        this.$router.push({ name: 'cashier', query: { tab } })
      },
    },
  }
</script>

<style lang="less" scoped>
.cashier-page-conteiner {
  min-height: 50vh;
  padding-top: 20px;
}

  .page-title {
    margin-bottom: 24px;
  }

  .tabs {
    border-bottom: 1px solid #9B9B9B;
    margin-bottom: 24px;

    @media (max-width: 768px) {
      flex-direction: column !important;
    }

    .tab {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      padding: 13px 0;
      cursor: pointer;
      text-align: center;

      // уже 1300px шрифт вкладок меньше; стоит до мобильного правила, чтобы
      // на 768px и уже остались его 16px
      @media (max-width: 1299px) {
        font-size: 20px;
      }

      @media (max-width: 768px) {
        font-size: 16px;
        padding: 8px 0;
      }

      // компактный десктоп: «Фискализация и печать» переносится на вторую
      // строку, и с обычным интервалом 1.5 между строками слишком пусто
      .media-compact-pc({
        line-height: 1;
      });

      &.active {
        background-color: #191919;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        span {
          color: @color-primary;
          font-weight: 500;
        }
      }
    }
  }

  .label {
    display: block;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 500;
  }

  .header-section {
    position: relative;
    background-color: @color-secondary;
    padding: 15px 15px;
    border-radius: 10px;
    margin-bottom: 24px;
    z-index: 0;

    .calendar-section {
      position: absolute;
      right: 15px;
      top: 100%;
      z-index: 1;

      &::v-deep {
        .v-date-picker-table--date th {
          font-size: 16px;
        }

        .v-date-picker-table {
          height: 370px;

          .v-btn {
            width: 52px;
            height: 52px;
            font-size: 18px;
          }
        }
      }
    }

    .button-header {
      flex: 1;
      height: 60px;
      font-size: 18px;
      margin-left: 15px;
      font-weight: 500;

      &:first-child {
        margin-left: 0;
      }

      svg {
        width: 20px;
        height: 20px;
        margin-right: 20px;
        .fill-svg(#ffffff);
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
</style>
